/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Volume_SameInputs */

const en_us2_wrapped_period_volume_same = /** @type {(inputs: Wrapped_Period_Volume_SameInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`The same volume as the month before.`);
	return /** @type {LocalizedString} */ (`The same volume as the year before.`)
	
};

const pt_br2_wrapped_period_volume_same = /** @type {(inputs: Wrapped_Period_Volume_SameInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`O mesmo volume do mês anterior.`);
	return /** @type {LocalizedString} */ (`O mesmo volume do ano anterior.`)
	
};

const es_419_wrapped_period_volume_same = /** @type {(inputs: Wrapped_Period_Volume_SameInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`El mismo volumen que el mes anterior.`);
	return /** @type {LocalizedString} */ (`El mismo volumen que el año anterior.`)
	
};

const pt_pt2_wrapped_period_volume_same = /** @type {(inputs: Wrapped_Period_Volume_SameInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`O mesmo volume do mês anterior.`);
	return /** @type {LocalizedString} */ (`O mesmo volume do ano anterior.`)
	
};

const fr_fr2_wrapped_period_volume_same = /** @type {(inputs: Wrapped_Period_Volume_SameInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Le même volume que le mois précédent.`);
	return /** @type {LocalizedString} */ (`Le même volume que l'année précédente.`)
	
};

const de_de2_wrapped_period_volume_same = /** @type {(inputs: Wrapped_Period_Volume_SameInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Dasselbe Volumen wie im Vormonat.`);
	return /** @type {LocalizedString} */ (`Dasselbe Volumen wie im Vorjahr.`)
	
};

const it_it2_wrapped_period_volume_same = /** @type {(inputs: Wrapped_Period_Volume_SameInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Lo stesso volume del mese precedente.`);
	return /** @type {LocalizedString} */ (`Lo stesso volume dell'anno precedente.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "The same volume as the month before." |
* | * | "The same volume as the year before." |
*
* @param {Wrapped_Period_Volume_SameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_volume_same = /** @type {((inputs: Wrapped_Period_Volume_SameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Volume_SameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_volume_same(inputs)
	if (locale === "es-419") return es_419_wrapped_period_volume_same(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_volume_same(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_volume_same(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_volume_same(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_volume_same(inputs)
	return en_us2_wrapped_period_volume_same(inputs)
});
export { wrapped_period_volume_same as "wrapped-period.volume_same" }